import { Box, ITheme, SvgIcon, Typography, useTheme } from '@mui/material'
import React, { useId, useState } from 'react'
import { ReactComponent as uploadIcon } from '../../../assets/upload.svg';
import { ReactComponent as fileIcon } from '../../../assets/file.svg'
import { useTranslation } from 'react-i18next';

export interface IUploadDocumentItemProps {
    index: number;
    onFileAdded: (file: File) => void;
    onCleared: () => void;
    file?: File;
}

const UploadDocumentItem: React.FC<IUploadDocumentItemProps> = ({ index, onFileAdded, file }) => {
    const id = useId();
    const theme = useTheme() as ITheme;
    const [showDropEffect, setShowDropEffect] = useState(false);
    const { t } = useTranslation();

    const onClick = () => {
        document.getElementById(id)?.click();
    }

    const onDragEnter = (ev: React.DragEvent<HTMLDivElement>) => {
        ev.preventDefault();
    }

    const onDragLeave = (ev: React.DragEvent<HTMLDivElement>) => {
        ev.preventDefault();
        setShowDropEffect(false);
    }

    const onDragOver = (ev: React.DragEvent<HTMLDivElement>) => {
        ev.preventDefault();
        setShowDropEffect(true);
    }

    const onDrop = (ev: React.DragEvent<HTMLDivElement>) => {
        ev.preventDefault();
        setShowDropEffect(false);
        if (ev.dataTransfer.files.length === 1) {
            onFileAdded(ev.dataTransfer.files.item(0) as File)
        }
    }

    return <Box display={"flex"} flexDirection={"column"} bgcolor={theme.palette.background.paper} borderRadius={"16px"} width={"240px"} padding={"24px 18px"} gap={"24px"}>
        <Typography fontSize={"18px"} fontWeight={"700"} lineHeight={"21.94px"} color={theme.palette.primary.dark}>{t('CreatePortfolioPortfolioDocument')} {index + 1}</Typography>
        {file === undefined ?
            <Box border={`1px dashed ${theme.palette.leo.type[400]}`} bgcolor={showDropEffect ? theme.palette.primary.light : undefined} display={"flex"} flexDirection={"column"} alignItems={"center"} gap={"33px"}
                padding={"25px 18px"} onClick={onClick} onDragEnter={onDragEnter} onDragLeave={onDragLeave} onDrop={onDrop} onDragOver={onDragOver} sx={{ cursor: "pointer" }}>
                <SvgIcon component={uploadIcon} inheritViewBox />
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"500"} textAlign={"center"}>{t('CreatePortfolioDragAndDrop')}</Typography>
            </Box>
            :
            <>
                <Typography fontSize={"12px"} lineHeight={"14.63px"} fontWeight={"500"}>{file.name}</Typography>
                <SvgIcon component={fileIcon} inheritViewBox style={{ width: "100%", height: "75px", color: theme.palette.primary.main }} />
            </>
        }
        <input type="file" id={id} style={{ display: "none" }} />
    </Box>
}

export default UploadDocumentItem